import React from 'react';
import {IconType, IconTabsOptions} from "../../icon-selector/@const";
import IconSelectorTab from "./icon-selector-tab";

type Props = {
    iconTypes   : IconType[]
    selectedTab : IconType
    onChangeTab : callback
}

export default function IconSelectorTabs(props: Props) {
    return (
        <div className="menu-underline ui5-bg-gog-light ui5-border-bottom h-40 p-h-10">

            {_.map(IconTabsOptions, (iconTabOption: Option, key: number)=> {

                if (!props.iconTypes.includes(iconTabOption.value)) return null

                const classes = Classes("item", "gd-popup-menu-btn", {"selected": iconTabOption.value === props.selectedTab })

                return <IconSelectorTab key             = {key}
                                        classes         = {classes}
                                        iconTabOption   = {iconTabOption}
                                        onChangeTab     = {props.onChangeTab}/>
            })}
        </div>
    );
}
